import { useTranslation } from 'react-i18next';

const Hero = () => {
  const { t } = useTranslation();

  const scrollToAbout = () => {
    const el = document.querySelector('#about');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" className="relative min-h-[600px] md:min-h-[760px] flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20sophisticated%20modern%20corporate%20office%20building%20with%20glass%20facade%20in%20Phnom%20Penh%20Cambodia%2C%20clean%20minimalist%20architecture%2C%20warm%20golden%20hour%20lighting%2C%20blue%20sky%20with%20soft%20clouds%2C%20professional%20business%20atmosphere%2C%20editorial%20photography%20style%2C%20high-end%20commercial%20real%20estate%2C%20subtle%20reflections%2C%20ultra%20clean%20composition%2C%20white%20and%20navy%20blue%20color%20tones%2C%208k%20quality&width=1920&height=900&seq=1&orientation=landscape"
          alt="LAVSTYLE modern corporate office in Phnom Penh Cambodia"
          title="LAVSTYLE Corporate Office Phnom Penh"
          className="w-full h-full object-cover object-center scale-105"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-navy-950/90 via-navy-900/75 to-navy-800/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 py-24 md:py-32">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-6 md:mb-8">
            <span className="w-10 h-px bg-gold-400" aria-hidden="true"></span>
            <p className="text-gold-300 text-xs md:text-sm font-medium tracking-[0.25em] uppercase">
              International Corporate
            </p>
          </div>
          <h1 className="text-3xl md:text-5xl lg:text-[3.5rem] font-bold text-white leading-[1.15] mb-4 tracking-tight">
            {t('hero_line1')}
          </h1>
          <p className="text-xl md:text-2xl lg:text-3xl text-white/85 font-light leading-relaxed mb-6 md:mb-8">
            <strong className="font-medium text-white">{t('hero_line2')}</strong>
          </p>
          <p className="text-sm md:text-base text-white/60 leading-relaxed max-w-lg mb-8 md:mb-12">
            {t('hero_desc')}
          </p>
          <button
            onClick={scrollToAbout}
            className="inline-flex items-center gap-3 bg-gold-400 text-navy-950 px-7 md:px-9 py-3.5 md:py-4 rounded-sm text-sm font-semibold hover:bg-gold-300 transition-all duration-300 whitespace-nowrap cursor-pointer group tracking-wide"
          >
            Learn More
            <span className="flex items-center justify-center w-5 h-5 group-hover:translate-x-1 transition-transform duration-300">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </button>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white to-transparent z-10"></div>
    </section>
  );
};

export default Hero;
